import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import { applicationSubmitSuccess, navigateWizard, mapServerToUi } from '../actions';
import ApplicationAPI from '../api/ApplicationAPI';
import { APPLICATION_SUBMIT } from '../constants/actionTypes';
import {
  APP_SUBMIT_HEAP,
  APP_SUBMIT_SUCCESS_HEAP,
  APP_SUBMIT_ERROR_HEAP,
} from '../constants/heapEvents';
import { track } from '../lib/heapHelpers';
import { buildServerSelector, accessTokenSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* applicationSubmitWatcher() {
  yield takeLatest(APPLICATION_SUBMIT, applicationSubmitWorker);
}

function* applicationSubmitWorker(action) {
  const builder = yield select(buildServerSelector);
  const { id: applicationId } = builder;
  try {
    yield call(track, APP_SUBMIT_HEAP, { 'Application GUID': applicationId });
    const accessToken = yield select(accessTokenSelector);
    const payload = yield call(ApplicationAPI.submitApplication, builder, accessToken);
    yield put(applicationSubmitSuccess({ response: payload }));
    yield put(mapServerToUi());
    yield call(track, APP_SUBMIT_SUCCESS_HEAP, { 'Application GUID': applicationId });
    yield put(navigateWizard({ dir: 'fwd' }));
  } catch (e) {
    yield call(track, APP_SUBMIT_ERROR_HEAP, { 'Application GUID': applicationId });
    yield fork(manageAPIError, { ...e, action });
  }
}

export { applicationSubmitWorker };
export default applicationSubmitWatcher;
